import type { Course } from '@rcs/data-schema';
import type { CourseInput } from '../worker/protocol';

/** コース（保存データ）から、Worker へ渡す計算用の入力（制御点の位置・周回・バンク角）を作る。 */
export function toCourseInput(course: Course): CourseInput {
  return {
    points: course.controlPoints.map((point) => point.position),
    closed: course.closed,
    banks: course.controlPoints.map((point) => point.bank),
  };
}
